import { render } from "./ArticleNavigation.vue?vue&type=template&id=03b96134"
import script from "./ArticleNavigation.vue?vue&type=script&lang=js"
export * from "./ArticleNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__